import React from 'react';
import './SpecificationsTable.css';

const SpecificationsTable = ({ specifications }) => {
  // Function to convert camelCase to Title Case with spaces
  const formatHeading = (camelCase) => {
    // Add space before uppercase letters and capitalize the first letter
    const withSpaces = camelCase.replace(/([A-Z])/g, ' $1');
    // Capitalize first letter and trim any extra spaces
    return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1).trim();
  };

  return (
    <div className="specs-table-container">
      <table className="specs-table">
        <tbody>
          {Object.entries(specifications).map(([key, value]) => (
            <tr key={key}>
              <th>
                {formatHeading(key)}
              </th>
              <td>
                {value}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SpecificationsTable;